export default __webpack_public_path__ + "static/media/esquinero2.3e3e3c46.png";